<template>
  <div class="NewLogista" v-loading="loadingPage">
    <el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
      <HeaderPage>
        <el-button @click.prevent="submitForm('ruleForm')" style="height: 44px; margin-left: 1rem">Salvar</el-button>
      </HeaderPage>
      <el-card shadow="never">
        <el-form-item prop="name" label="Nome">
          <el-input size="large" v-model="ruleForm.name" required />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :lg="12" :sm="12" :xs="24">
            <el-form-item prop="marketplace_id" label="Marketplace">
              <SelectSearchMarketplace :model="ruleForm.marketplace_id" :isEdit="false" @handleObjValue="handleMKT" @handleValue="(x) => {$set(ruleForm, 'marketplace_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :sm="6" :xs="24">
            <el-form-item prop="provider_id" label="Provider">
              <SearchProviders :model="ruleForm.provider_id" :isEdit="false" @handleValue="(x) => {$set(ruleForm, 'provider_id', x)}" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :sm="6" :xs="24">
            <el-form-item prop="id_external" label="ID Externo do grupo de Lojista">
              <el-input size="large" v-model="ruleForm.id_external" required />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-if="showCNPJ" prop="cnpj" label="CNPJ">
          <div style="    margin-top: 23px;">
            <el-radio style="    height: 52px;" v-for="bus in listBussiness" :key="bus.id" v-model="ruleForm.cnpj" :label="bus.business_cnpj" border>
              <div style="display: flex;    flex-direction: column;    justify-content: center;    margin-left: 18px;    margin-top: -16px;">
                <strong>{{bus.business_name}}</strong>
                <span>{{bus.business_cnpj}}</span>
              </div>
            </el-radio>
          </div>
        </el-form-item>

<!--        <el-card v-if="showCNPJ"  shadow="never">-->
<!--          <span>Selecione os Estabelecimentos que deseja associar a este grupos</span> <br> <br> <br>-->
<!--          <TableSimple :multipleSelect="true" ref="tableECs" :list-data="listDataEcs" @paginationClick="paginationClick">-->
<!--            <el-table-column prop="id" label="#" width="80">-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="person.name_store" label="Nome da loja">-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="person.name" label="Nome">-->
<!--            </el-table-column>-->
<!--          </TableSimple>-->
<!--        </el-card>-->

      </el-card>
    </el-form>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import SearchProviders from "@/app/components/Providers/SearchProviders";
import {postMarketplaces, putMarketplaces} from "@/app/domains/Records/services";
import {clearRuleForm, getErrorFilds, makeErrorFilds} from "@/app/plugins/utils";
import {getCardBrand, getLogista, getMarketplace, getMCC, postLogista, putLogista} from "@/app/domains/Config/services";
import TableSimple from "@/app/components/Table/TableSimple";
import {getEstaComercial} from "@/app/domains/Report/services";

export default {
  name: "EditNewLojista",
  components: {
    HeaderPage,
    SelectSearchMarketplace,
    SearchProviders,
    // TableSimple,
  },
  data () {
    return {
      loadingPage: false,
      showCNPJ: false,
      listBussiness: [],
      listDataEcs: {},
      ruleForm: {
        marketplace_id: '',
        provider_id: '',
        cnpj: '',
      },
      rules: {
        name: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        marketplace_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        provider_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        cnpj: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
      },
      queryS: ''
    }
  },
  methods: {
    // paginationClick (arg) {
    //   this.listEstaComercial(this.queryS+'&page='+arg.page)
    // },
    // async listEstaComercial (query = '') {
    //   this.loadingPage = true
    //   try {
    //     let response = await getEstaComercial(query)
    //     this.listDataEcs = response.data
    //   } catch (e) {
    //     this.$message({
    //       showClose: true,
    //       message: 'Erro ao carregar lista',
    //       type: 'error'
    //     })
    //   } finally {
    //     this.loadingPage = false
    //   }
    // },
    async handleMKT (x) {
      if (x.person.type_person === 'business') {
        this.loadingPage = true
        try {
          const response = await getMarketplace('/'+x.id)
          this.listBussiness = response.data.person.business
          // this.queryS = '?martketplace_id='+response.data.id
          // await this.listEstaComercial('?marketplace_id=' + response.data.id)
        } catch (e) {
          this.error = getErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      } else {
        delete this.ruleForm.cnpj
      }
      this.showCNPJ = (x.person.type_person === 'business')
    },
    submitForm (ruleForm) {
      
      this.$refs[ruleForm].validate(async (valid, i) => {
        if (valid) {
          try {
            this.loadingPage = true
            this.ruleForm.cnpj = this.ruleForm.cnpj?.replace(/[^\d]+/g, '')
            if (this.$route.params.id) {
              await putLogista(this.ruleForm)
            } else {
              await postLogista(this.ruleForm)
            }
            this.$message({
              showClose: true,
              message: 'Adicionado com sucesso',
              type: 'success'
            })
            await this.$router.push({name: 'config.lojista.index'})
          } catch (e) {
            this.error = getErrorFilds(e)
            this.activeNameTabs = "address"
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }
      })
    }
  },
  async beforeMount() {
    if (this.$route.params.id !== undefined) {
      this.loadingPage = true
      try {
        let response = await getLogista(`/${this.$route.params.id}`)
        this.ruleForm = response.data
        
      } catch (e) {
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  }
}
</script>

<style scoped>

</style>
